import { CalendarSyncRequest, CalendarSyncResponse } from '../types';
import { ApiClient } from '../../../utils/apiClient';
import { handleApiResult, handleApiCatch } from '../../../utils/apiErrorHandler';

export const syncService = {
  // Sync calendar events
  sync: async (
    calendarId: string,
    forceSync: boolean = false,
    syncEvents: boolean = true
  ): Promise<CalendarSyncResponse> => {
    try {
      const response = await ApiClient.post('/calendars/sync/', {
        calendar_id: calendarId,
        force_sync: forceSync,
        sync_events: syncEvents,
      } as CalendarSyncRequest);
      const result = await handleApiResult<CalendarSyncResponse>(
        response,
        'Failed to sync calendar events'
      );
      if (!result.success || !result.data) {
        // Extract detailed error message from backend
        const errorMessage =
          result.errors?.generalError ||
          result.errors?.nonFieldErrors?.[0] ||
          result.errors?.fieldErrors?.[Object.keys(result.errors.fieldErrors || {})[0]] ||
          'Failed to sync calendar events';
        throw new Error(errorMessage);
      }
      return result.data;
    } catch (error) {
      // If it's already an Error with a message, re-throw it
      if (error instanceof Error) {
        throw error;
      }
      // Otherwise, process the error
      const processedErrors = handleApiCatch(error, 'Failed to sync calendar events');
      throw new Error(processedErrors.generalError || 'Failed to sync calendar events');
    }
  },
};
